module.exports = __webpack_public_path__ + "static/media/client19.87e06721.webp";